import React, { FC, Fragment, useEffect, useState } from 'react';
import { Card } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { omit } from 'lodash';
import LinearProgress from '@material-ui/core/LinearProgress';

import { ContentInput } from 'api';
import { getPhoto, getVideo } from 'features/content/helpers';
import { Photo as PhotoWidget } from 'features/content/widgets';
import { Dimensions, Video as VideoPlayer } from 'components';
import { useNotify } from 'hooks';
import { uploadVideo } from 'features/posting/helpers';
import { DimensionsProvider } from 'providers';

const MediaPreview: FC = () => {
  const { values, setFieldValue } = useFormikContext<ContentInput>();
  const notify = useNotify();

  const photo = getPhoto(values);
  const video = getVideo(values);

  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    const needsUpload = video && !!video.file;

    async function sendVideo() {
      try {
        await uploadVideo(video, value => setUploadProgress(value));
        setFieldValue('content_object.media.video', omit(video, 'file', 'uploading'));
      } catch (error) {
        notify.mutationError();
      }
    }

    if (needsUpload) {
      void sendVideo();
    }
  }, [video]);

  return (
    <Card>
      {!video && photo && (
        <Dimensions>
          {dimensions => (
            <DimensionsProvider value={{ dimensions }}>
              <PhotoWidget photo={photo} />
            </DimensionsProvider>
          )}
        </Dimensions>
      )}

      {video && (
        <Fragment>
          <LinearProgress variant="determinate" value={uploadProgress} />
          <VideoPlayer video={video} />
        </Fragment>
      )}
    </Card>
  );
};

export default MediaPreview;
